import type { JSX } from 'react';
import { FileUpload } from '@/components/ui/file-upload';
import { ACCEPTED_IMAGE_TYPES } from './EditCompanyDialog.utils';

interface CompanyLogoFieldsProps {
  logoFile: File | null;
  darkLogoFile: File | null;
  onLogoChange: (file: File | null) => void;
  onDarkLogoChange: (file: File | null) => void;
}

export function CompanyLogoFields({
  logoFile,
  darkLogoFile,
  onLogoChange,
  onDarkLogoChange,
}: CompanyLogoFieldsProps): JSX.Element {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <FileUpload
        label="Logo"
        accept={ACCEPTED_IMAGE_TYPES}
        value={logoFile}
        onChange={onLogoChange}
      />
      <FileUpload
        label="Dark Logo"
        accept={ACCEPTED_IMAGE_TYPES}
        value={darkLogoFile}
        onChange={onDarkLogoChange}
      />
    </div>
  );
}
